import GpsCoordinates from '@th/shared/src/types/GpsCoordinates';
import StaticPointMap from './StaticPointMap';
import Link from 'next/link';
import { SELECTED_PLACE_ZOOM } from '@th/shared/src/constants/map';
import SvgIcon from '../icons/SvgIcon';
import React from 'react';

type Props = {
  coordinates: GpsCoordinates;
};

export default function StaticMapWithButton({ coordinates }: Props) {
  return (
    <>
      <StaticPointMap coordinates={coordinates} />
      <div className="absolute top-3 right-3 ">
        <Link
          target="_blank"
          href={`/m?lng=${coordinates.longitude}&lat=${coordinates.latitude}&zoom=${SELECTED_PLACE_ZOOM}&pinLat=${coordinates.latitude}&pinLng=${coordinates.longitude}`}
          aria-label="Open in map"
        >
          <div className="p-2 bg-white rounded-full border border-darkGray shadow-2xl hover:bg-gray-200">
            <SvgIcon name={'HiArrowTopRightOnSquare'} className="h-6 w-6" />
          </div>
        </Link>
      </div>
    </>
  );
}
